<!--
 * @Author: ymk
 * @Date: 2020-07-23 19:05:08
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-23 20:03:34
 * @FilePath: \car-demo\src\components\Panel.vue
-->
<template>
	<nut-row class="row" type="flex" align="center">
		<nut-col :span="8" class="col">
			<div class="flex-content">
				<p class="value">{{Number(data.view_count) + 1}}</p>
				<p class="label">浏览次数</p>

                <img class="icon icon-liulan" src="../assets/images/liulan.png" alt="浏览次数">
			</div>
		</nut-col>
		<nut-col :span="8" class="col">
			<div class="flex-content flex-content-light">
				<p class="value">{{data.buy_num}}</p>
				<p class="label">购买用户</p>

                <img class="icon icon-goumai" src="../assets/images/goumai.png" alt="购买用户">
			</div>
		</nut-col>
		<nut-col :span="8" class="col">
			<div class="flex-content flex-content-light">
				<p class="value">{{data.share_count}}</p>
				<p class="label">分享用户</p>
                
                <img class="icon icon-fenxiang" src="../assets/images/fenxiang.png" alt="分享用户">
			</div>
		</nut-col>
	</nut-row>
</template>

<script>
export default {
    props:{
        data:{type: Object , required: false},

	}

}
</script>

<style lang="less" scoped>
.row {
	height: 70px;
	background: linear-gradient(
		180deg,
		rgba(0, 194, 255, 1) 0%,
		rgba(60, 67, 236, 1) 100%
	);
	box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	margin: 20px 14px;
	padding: 10px;

	.col,
	.flex-content {
		position: relative;
		height: 100%;
	}
	.col:not(:last-child)::before {
		content: '';
		position: absolute;
		right: 0;
		top: 50%;
		width: 1px;
		height: ~'calc(100% - (17px * 2))';
		transform: translateY(-50%);
		background-color: rgba(255, 255, 255, 0.2);
    }
	.col:nth-child(1) {
        padding-right: 15px;
    }
	.col:nth-child(2) {
		padding: 0 15px;
	}
	.col:nth-child(3) {
		padding-left: 15px;
	}
	.value {
		font-size: 15px;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		line-height: 20px;
        margin-bottom: 3px;
        padding-top: 5px;
	}
	.label {
		font-size: 12px;
		font-weight: 400;
		line-height: 15px;
		color: rgba(255, 255, 255, 1);
    }
    .icon {
        position: absolute;
        right: 0;
        bottom: 0;
        &-liulan {
            width: 26px;
            height: 21px;
        }
        &-goumai {
            width: 24px;
            height: 23px;
        }
        &-fenxiang {
            width: 25px;
            height: 23px;
        }
    }
}
</style>
